import React, { useContext } from 'react';
import './Type1.scss';
import intl from 'react-intl-universal';
import { getGalleryStatus } from '../../utils/util';
import { IGalleryType, IGalleryData, IGalleryList } from './GalleryType';
import { inject, observer } from 'mobx-react';
import Lock from './Lock';
import { IGalleryStatus, IViewDetail } from '../../global.d';
import { direct, style } from '../../utils/image';
import { navigatorTo } from '../../utils/util';
import StatusTag from '../Tag/StatusTag';
import StatisticsRow from '../StatisticsRow';
import { ThemeContext } from '../../store/ThemeProvider';
import uImageCount from './useImageCount';
import { renderGalleryName } from './AllForGallery';
import classNames from 'classnames';
// 这是原来的type3
interface IType1 extends IGalleryType {
  desc?: string;
}
const Type1 = (props: IType1) => {
  const {
    image,
    link, 
    gallerys = {} as IGalleryList,
    info = true,
    total = true,
    showname = true,
    namealign = 'left',
    imageadjust = false,
    desc
  } = props;
  console.log(props);
  const { h1Color, h2Color } = useContext(ThemeContext);
  const loc = intl.getInitOptions().currentLocale;

  const { view_detail, image_total, gallery } =
    ['subgallery', 'gallery'].indexOf(link.type) > -1
      ? uImageCount(link, gallerys)
      : {
          view_detail: null,
          image_total: 0,
          gallery: {
            name: desc,
            status: '',
            start_time: '',
            end_time: '',
            is_pay_down:0
          }
        };

  const [statusName, statusColor] = gallery
    ? getGalleryStatus(gallery.status as IGalleryStatus)
    : ['', ''];

  return (
    <div
      className={classNames("type1-wrapper type-wrapper", !!imageadjust && 'imageadjust')}
      onClick={() => {
        props.onClick(link);
      }}
      // data-id={id}
    >
      <div className="main">
        <div className="content">
          <div className="left-content">
            <img
              src={
                style(image, !!imageadjust ? 'wx_gallery_a_1' : 'wx_gallery_mode_1') ||
                require('../../assets/pic-bg.png')
              }
              className="bg"
              alt=""
            />
            {gallery && Number(gallery.is_pay_down) ? <StatusTag
              status={IGalleryStatus.needpay}
              className={'status pay-status'}
              fontSize={12}
            /> : null}
            {/*<Lock />*/}
          </div>
          <div className="right-content">
            {showname ? <div className={"title " + namealign} style={{ color: h1Color }}>
              <div className="row1" />
              <div className="real-title">{renderGalleryName((gallery || {})!.name, link ? link.desc : '')}</div>
              <div className="last-row" />
            </div> : null}
            <div className={'a-c'} style={{ marginLeft: '-4px' }}>
              {!!view_detail && (info || total) ? (
                <>
                  {total ? (
                    <StatisticsRow
                      n1={image_total}
                      n2={view_detail.view || 0}
                      fontSize={11}
                      fontColor={h2Color}
                    />
                  ) : null}
                  <div className="flex1" />
                  {info ? (
                    <div
                      style={{
                        color: statusColor,
                        fontSize: 12,
                        flexShrink: 0
                      }}
                      className={'a-c'}
                    >
                      {/*statusName*/}
                      <StatusTag
                        status={(gallery || {}).status as IGalleryStatus}
                        className={'status'}
                        invert={true}
                        fontSize={12}
                        startTime={(gallery || ({} as IGalleryData)).start_time}
                        endTime={(gallery || ({} as IGalleryData)).end_time}
                      />{' '}
                      <span
                        className="icon-right-arrow"
                        style={{ marginLeft: 6 }}
                      />
                    </div>
                  ) : null}
                </>
              ) : (
                <div style={{ height: 19 }} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default inject('rootStore')(observer(Type1));
